export default "__VITE_ASSET__DhNaZgKC__"